// Hero - Homepage

// Lazy-load the hero video after the initial page load so it doesn't
// compete with critical above-the-fold assets. The video element keeps
// its autoplay/muted/playsinline attributes, so once the source loads
// the browser autoplays it natively - no manual .play() call needed.
window.addEventListener('load', function () {
	document.querySelectorAll('.hero-homepage-video').forEach(function (video) {
		var source = video.querySelector('source[data-src]');

		if (!source) {
			return;
		}

		source.src = source.dataset.src;
		source.removeAttribute('data-src');
		video.load();
	});
});